var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemmtoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 0C22.1262 0 24.8125 2.68629 24.8125 6V18C24.8125 21.3137 22.1262 24 18.8125 24H6.8125C3.49879 24 0.8125 21.3137 0.8125 18V6C0.8125 2.68629 3.49879 0 6.8125 0H18.8125Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29939 9.01177C5.35955 3.36917 13.9545 2.59766 15.5457 7.72547C15.7529 8.39403 15.8051 9.12275 15.8278 9.81939C18.0113 9.68568 20.025 10.7032 20.8821 12.761C22.2419 16.0209 20.4248 20.0884 16.6849 20.293H12.3072C12.354 19.7193 12.4342 18.8583 12.7645 18.3742C12.8808 18.2044 13.1094 17.9771 13.421 17.9771C13.9585 17.9771 14.9038 17.9771 15.6861 17.9771C16.7504 17.9771 17.6743 17.8781 18.3456 17.0438C19.1585 16.0329 19.1879 14.0126 18.2988 12.9562C17.9685 12.5645 17.3628 12.1553 16.4027 12.1486H13.4464C13.4464 11.5576 13.4504 10.7915 13.4464 10.0413C13.441 8.81254 13.2793 7.58508 12.1347 6.97268C11.172 6.45789 9.5661 6.52475 8.67826 7.17726C7.79042 7.82977 7.6888 8.89678 7.69816 9.98519C7.70351 10.7193 7.71421 11.4774 7.65537 12.1326C7.62061 12.515 7.4187 12.7477 7.09646 12.9308C6.53086 13.2517 5.93585 13.2932 5.29805 13.3133C5.30607 12.6755 5.28334 10.4104 5.29805 9.01445L5.29939 9.01177Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47057 20.2827C8.66541 20.2827 9.63402 19.3135 9.63402 18.1179C9.63402 16.9223 8.66541 15.9531 7.47057 15.9531C6.27574 15.9531 5.30713 16.9223 5.30713 18.1179C5.30713 19.3135 6.27574 20.2827 7.47057 20.2827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemmtoIcon);
export default __webpack_public_path__ + "static/media/femmto-icon.f54e79ada0e3d3aa96c0c118e6636b24.svg";
export { ForwardRef as ReactComponent };